package com.gsb.vyapar.bhagya.datasource.cache

import kotlin.Boolean
import kotlin.Long
import kotlin.String

public data class CategoryEntity(
  public val id: Long,
  public val name: String,
  public val imageUrl: String,
  public val deleted: Boolean,
)
